import React from "react";

interface CompletedListIconProps {
  className?: string;
  onClick?: () => void;
}

export const CompletedListIcon = ({
  className,
  onClick,
}: CompletedListIconProps) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M10.5 2C10.9167 2 11.2708 2.14583 11.5625 2.4375C11.8542 2.72917 12 3.08333 12 3.5V14.5C12 14.9167 11.8542 15.2708 11.5625 15.5625C11.2708 15.8542 10.9167 16 10.5 16H1.5C1.08333 16 0.729167 15.8542 0.4375 15.5625C0.145833 15.2708 0 14.9167 0 14.5V3.5C0 3.08333 0.145833 2.72917 0.4375 2.4375C0.729167 2.14583 1.08333 2 1.5 2H4.28125C4.26042 1.91667 4.25 1.83333 4.25 1.75C4.25 1.27083 4.41667 0.864583 4.75 0.53125C5.10417 0.177083 5.52083 0 6 0C6.47917 0 6.88542 0.177083 7.21875 0.53125C7.57292 0.864583 7.75 1.27083 7.75 1.75C7.75 1.83333 7.73958 1.91667 7.71875 2H10.5ZM6.53125 1.21875C6.38542 1.07292 6.20833 1 6 1C5.79167 1 5.61458 1.07292 5.46875 1.21875C5.32292 1.36458 5.25 1.54167 5.25 1.75C5.25 1.95833 5.32292 2.13542 5.46875 2.28125C5.61458 2.42708 5.79167 2.5 6 2.5C6.20833 2.5 6.38542 2.42708 6.53125 2.28125C6.67708 2.13542 6.75 1.95833 6.75 1.75C6.75 1.54167 6.67708 1.36458 6.53125 1.21875ZM11 14.5V3.5C11 3.35417 10.9479 3.23958 10.8438 3.15625C10.7604 3.05208 10.6458 3 10.5 3H9V3.625C9 3.875 8.875 4 8.625 4H3.375C3.125 4 3 3.875 3 3.625V3H1.5C1.35417 3 1.22917 3.05208 1.125 3.15625C1.04167 3.23958 1 3.35417 1 3.5V14.5C1 14.6458 1.04167 14.7604 1.125 14.8438C1.22917 14.9479 1.35417 15 1.5 15H10.5C10.6458 15 10.7604 14.9479 10.8438 14.8438C10.9479 14.7604 11 14.6458 11 14.5ZM9.15625 7.125L9.4375 7.375C9.60417 7.5625 9.60417 7.73958 9.4375 7.90625L5.21875 12.0938C5.03125 12.2604 4.85417 12.2604 4.6875 12.0938L2.5625 9.96875C2.39583 9.80208 2.39583 9.625 2.5625 9.4375L2.84375 9.1875C3.03125 9 3.20833 9 3.375 9.1875L4.9375 10.75L8.625 7.125C8.8125 6.9375 8.98958 6.9375 9.15625 7.125Z"
      fill="#666666"
    />
  </svg>
);

CompletedListIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
